module.exports = __webpack_public_path__ + "assets/img/Superdraft-Social-Static-Ad-1-w960.abea918b.png";